import React, { useEffect, useState } from "react";
import { useParams, useLocation, Link } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import api from "@/lib/api";

const TITLES = {
  terms: "Terms of Service",
  privacy: "Privacy Policy",
  "data-handling": "Customer Data Handling",
  cookies: "Cookie Policy",
};

export default function PublicLegal() {
  const params = useParams();
  const location = useLocation();
  // Slug derived either from /:slug param or first path segment for fixed routes
  const slug = params.slug || location.pathname.split("/").filter(Boolean)[0];
  const [doc, setDoc] = useState(null);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    setErr("");
    setDoc(null);
    api.get(`/public/legal/${slug}`)
      .then(r => setDoc(r.data))
      .catch(e => setErr(e.response?.status === 404
        ? "This page hasn't been published yet."
        : (e.response?.data?.detail || e.message)))
      .finally(() => setLoading(false));
  }, [slug]);

  return (
    <div style={{ maxWidth: 820, margin: "0 auto", padding: "60px 24px 80px" }}>
      <Link to="/" data-testid="legal-home-link"
            className="font-mono"
            style={{ fontSize: 11, letterSpacing: ".15em", color: "var(--ink-mute)", textDecoration: "none" }}>
        ← BACK TO CANADAMRO EXCHANGE
      </Link>
      <h1 className="font-serif-display" data-testid={`legal-title-${slug}`}
          style={{ fontSize: 40, fontWeight: 600, marginTop: 24, marginBottom: 6, lineHeight: 1.15 }}>
        {doc?.title || TITLES[slug] || "Legal"}
      </h1>
      {doc?.version != null && (
        <div className="font-mono" style={{ fontSize: 11, letterSpacing: ".1em", color: "var(--ink-mute)", marginBottom: 32 }}>
          v{doc.version} · {doc.updated_at ? new Date(doc.updated_at).toLocaleDateString() : ""}
        </div>
      )}
      {loading && <p style={{ color: "var(--ink-mute)" }}>Loading…</p>}
      {err && !loading && <p data-testid="legal-error" style={{ color: "var(--ink-mute)" }}>{err}</p>}
      {doc && !loading && (
        <article data-testid={`legal-body-${slug}`} className="legal-body">
          <ReactMarkdown>{doc.body_markdown || ""}</ReactMarkdown>
        </article>
      )}
    </div>
  );
}
